// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CvGenerationController from "./cv_generation_controller"
application.register("cv-generation", CvGenerationController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MonthPickerController from "./month_picker_controller"
application.register("month-picker", MonthPickerController)
